export default "__VITE_ASSET__CbyjR$yX__"